"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _reactTippy = require("react-tippy");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _ = require("../");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledHeaderRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 2rem;\n"])));

var StyledTitle = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.theme.colorLabel;
});

var StyledStepRow = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-around;\n"])));

var StyledStep = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 0 0 33.33%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    z-index: 1;\n    top: 22px;\n    width: 100%;\n    height: 3px;\n    background: ", ";\n  }\n\n  &:first-child::after {\n    width: 50%;\n    left: 50%;\n  }\n\n  &:last-child::after {\n    width: 50%;\n    right: 50%;\n  }\n"])), function (p) {
  return p.allValid ? (0, _polished.rgba)(p.theme.colorSuccess, 0.1) : p.theme.colorBorder;
});

var StyledStepInner = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));

var StyledStepBubble = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  margin-bottom: 0.75rem;\n  border-radius: 50%;\n  border: 3px solid white;\n  font-family: ", ";\n  background: ", ";\n\n  color: ", ";\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background: white;\n  }\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.isSuccess ? (0, _polished.rgba)(p.theme.colorSuccess, 0.1) : p.theme.colorLightGrey;
}, function (p) {
  return p.isSuccess ? p.theme.colorSuccess : p.theme.colorLabel;
});

var StyledBubbleBadge = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 2px solid white;\n  background: ", ";\n  color: white;\n"])), function (p) {
  return p.isSuccess ? p.theme.colorSuccess : p.theme.colorDanger;
});

var StyledStepText = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 0.675rem;\n  font-family: ", ";\n  text-align: center;\n  color: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.isSuccess ? p.theme.colorSuccess : p.theme.colorLabel;
});

var StyledTooltipInner = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 160px;\n  font-weight: 400;\n  font-size: 0.75rem;\n  font-family: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
});

var StyledTooltipButton = _styledComponents.default.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: white;\n  border-radius: 0.25rem;\n  width: 100%;\n  padding: 0.625rem 0;\n  font-size: 0.75rem;\n  font-family: ", ";\n"])), function (p) {
  return p.theme.colorSuccess;
}, function (p) {
  return p.theme.fontFamilyDefault;
});

var WalletHelp = function WalletHelp(_ref) {
  var translations = _ref.translations,
      addCard = _ref.addCard,
      onError = _ref.onError,
      phoneVerified = _ref.phoneVerified,
      cardAdded = _ref.cardAdded,
      isLoading = _ref.isLoading;
  var theme = (0, _.useStyledTheme)();
  var history = (0, _reactRouterDom.useHistory)();

  var CustomTooltip = function CustomTooltip(_ref2) {
    var children = _ref2.children,
        rest = _objectWithoutProperties(_ref2, ["children"]);

    return /*#__PURE__*/_react.default.createElement(_reactTippy.Tooltip, _extends({
      trigger: "click",
      interactive: true,
      arrow: true,
      distance: 15
    }, rest), children);
  };

  var TooltipTheme = function TooltipTheme(_ref3) {
    var children = _ref3.children;
    return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
      theme: theme
    }, children);
  };

  var PhoneVerifiedTooltip = /*#__PURE__*/_react.default.createElement(TooltipTheme, null, /*#__PURE__*/_react.default.createElement(StyledTooltipInner, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: "1rem"
    }
  }, translations.messageVerifyPhoneHelp), /*#__PURE__*/_react.default.createElement(StyledTooltipButton, {
    onClick: function onClick() {
      return history.push("/confirm-phone");
    }
  }, translations.howToWithdrawStep1)));

  var CardAddedTooltip = /*#__PURE__*/_react.default.createElement(TooltipTheme, null, /*#__PURE__*/_react.default.createElement(StyledTooltipInner, null, /*#__PURE__*/_react.default.createElement("div", null, translations.messageAddCardHelp), /*#__PURE__*/_react.default.createElement(StyledTooltipButton, {
    onClick: function onClick() {
      return addCard();
    }
  }, translations.addCard)));

  var TapWithdrawTooltip = /*#__PURE__*/_react.default.createElement(TooltipTheme, null, /*#__PURE__*/_react.default.createElement(StyledTooltipInner, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: "1rem"
    }
  }, translations.messageTapWithdrawHelp), /*#__PURE__*/_react.default.createElement(StyledTooltipButton, {
    to: "/confirm-phone"
  }, translations.howToWithdrawStep1)));

  var TapWithdrawTooltipValid = /*#__PURE__*/_react.default.createElement(TooltipTheme, null, /*#__PURE__*/_react.default.createElement(StyledTooltipInner, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: "1rem"
    }
  }, translations.messageTapWithdrawHelp2), /*#__PURE__*/_react.default.createElement(StyledTooltipButton, {
    disabled: true,
    disabledSuccess: true,
    disabledSuccessIcon: "  "
  }, translations.howToWithdrawStep3)));

  return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, null, /*#__PURE__*/_react.default.createElement(StyledHeaderRow, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledTitle, null, translations.howToWithdraw))), /*#__PURE__*/_react.default.createElement(StyledStepRow, null, /*#__PURE__*/_react.default.createElement(StyledStep, {
    allValid: phoneVerified && cardAdded
  }, /*#__PURE__*/_react.default.createElement(CustomTooltip, {
    html: PhoneVerifiedTooltip,
    disabled: phoneVerified
  }, /*#__PURE__*/_react.default.createElement(StyledStepInner, null, isLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "40px",
    skeletonHeight: "40px",
    isCircle: true,
    margin: "3px 0 14px"
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "70px",
    margin: "0 0 1px"
  })), !isLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledStepBubble, {
    isSuccess: phoneVerified
  }, "1", /*#__PURE__*/_react.default.createElement(StyledBubbleBadge, {
    isSuccess: phoneVerified
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, {
    size: "10px"
  }, phoneVerified ? "check" : "close"))), /*#__PURE__*/_react.default.createElement(StyledStepText, {
    isSuccess: phoneVerified
  }, translations.howToWithdrawStep1))))), /*#__PURE__*/_react.default.createElement(StyledStep, {
    allValid: phoneVerified && cardAdded
  }, /*#__PURE__*/_react.default.createElement(CustomTooltip, {
    html: CardAddedTooltip,
    disabled: cardAdded || !phoneVerified ? true : false
  }, /*#__PURE__*/_react.default.createElement(StyledStepInner, null, isLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "40px",
    skeletonHeight: "40px",
    isCircle: true,
    margin: "3px 0 14px"
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "70px",
    margin: "0 0 1px"
  })), !isLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledStepBubble, {
    isSuccess: cardAdded ? true : false
  }, "2", /*#__PURE__*/_react.default.createElement(StyledBubbleBadge, {
    isSuccess: cardAdded ? true : false
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, {
    size: "10px"
  }, cardAdded ? "check" : "close"))), /*#__PURE__*/_react.default.createElement(StyledStepText, {
    isSuccess: cardAdded ? true : false
  }, translations.howToWithdrawStep2))))), /*#__PURE__*/_react.default.createElement(StyledStep, {
    allValid: phoneVerified && cardAdded
  }, /*#__PURE__*/_react.default.createElement(CustomTooltip, {
    disabled: cardAdded && phoneVerified,
    html: cardAdded && phoneVerified ? TapWithdrawTooltipValid : null
  }, /*#__PURE__*/_react.default.createElement(StyledStepInner, null, isLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "40px",
    skeletonHeight: "40px",
    isCircle: true,
    margin: "3px 0 14px"
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "70px",
    margin: "0 0 1px"
  })), !isLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledStepBubble, {
    isSuccess: cardAdded && phoneVerified ? true : false
  }, "3", /*#__PURE__*/_react.default.createElement(StyledBubbleBadge, {
    isSuccess: cardAdded && phoneVerified ? true : false
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, {
    size: "10px"
  }, cardAdded && phoneVerified ? "check" : "close"))), /*#__PURE__*/_react.default.createElement(StyledStepText, {
    isSuccess: cardAdded && phoneVerified
  }, translations.howToWithdrawStep3)))))));
};

var _default = WalletHelp;
exports.default = _default;